import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/portfolio/Navbar";
import { Hero } from "@/components/portfolio/Hero";
import { EditorialMarquee } from "@/components/portfolio/Marquee";
import { Headshots } from "@/components/portfolio/Headshots";
import { Showreel } from "@/components/portfolio/Showreel";
import { About } from "@/components/portfolio/About";
import { Vita } from "@/components/portfolio/Vita";
import { Press } from "@/components/portfolio/Press";
import { Contact } from "@/components/portfolio/Contact";
import { Footer } from "@/components/portfolio/Footer";
import { LanguageProvider } from "@/lang";

export default function Portfolio() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
    <div data-testid="portfolio-page" className="grain bg-[#050505] text-zinc-100">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Headshots />
        <Showreel />
        <About />
        <Vita />
        <Press />
        <Contact />
      </main>
      <Footer />
    </div>
    </LanguageProvider>
  );
}
